import React, { useState } from 'react';

// Hooks
import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import Button from '@/components/base/Button';
import InfoBanner from '@/components/base/InfoBanner';
import Modal from '@/components/base/Modal';

const DeleteCaptionModal = ({ isOpen, toggle, deleteCaption }) => {
    const { t } = useTranslation('media');

    const [deleteState, setDeleteState] = useState({
        isSubmitting: false,
        error: null
    });

    const confirm = async () => {
        setDeleteState({
            isSubmitting: true,
            error: null
        });
        try {
            await deleteCaption();
            toggle();
            setDeleteState((prevState) => ({ ...prevState, isSubmitting: false }));
        } catch (e) {
            setDeleteState({
                isSubmitting: false,
                error: t('errors:error_occurred_delete_data')
            });
        }
    };

    return (
        <Modal open={isOpen} onDismiss={toggle} className="!z-100">
            <Modal.Body>
                {deleteState.error ? (
                    <InfoBanner
                        className="mb-4"
                        title={t('errors:error')}
                        message={deleteState.error}
                        onClose={() => {
                            setDeleteState((prevState) => ({
                                ...prevState,
                                error: null
                            }));
                        }}
                    />
                ) : null}
                <Modal.Title>{t('delete_caption')}</Modal.Title>
                <Modal.Content>
                    <p className="pt-m text-center font-GMedium text-base text-icoGray-500">
                        {t('delete_caption_confirm')}
                    </p>
                </Modal.Content>
                <Modal.Footer className="my-8 flex justify-between space-x-6">
                    <Button
                        variant="secondary"
                        className="w-full"
                        disabled={deleteState.isSubmitting}
                        onClick={toggle}>
                        {t('commons:no')}
                    </Button>
                    <Button
                        className="w-full"
                        isLoading={deleteState.isSubmitting}
                        disabled={deleteState.isSubmitting}
                        onClick={confirm}>
                        {t('commons:yes')}
                    </Button>
                </Modal.Footer>
            </Modal.Body>
        </Modal>
    );
};

export default DeleteCaptionModal;
